<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content [showDefaultFormFooter]="true" [contentClasses]="['floatingLabelContainer']">
        @if (config.data?.extended?.fromGlobalView) {
            <p-floatlabel variant="on">
                <p-select
                    inputId="customer_uuid"
                    [autoDisplayFirst]="false"
                    [options]="customers"
                    [filter]="true"
                    formControlName="customer_uuid"
                    optionLabel="name"
                    optionValue="uuid"
                    appendTo="body"
                    [showClear]="true"
                    emptyMessage="No Customer found"
                >
                </p-select>
                <label for="customer_uuid">Customer</label>
            </p-floatlabel>
        }

        <p-floatlabel variant="on">
            <p-select
                #user_uuid
                inputId="user_uuid"
                [autoDisplayFirst]="false"
                [options]="users"
                [filter]="true"
                formControlName="user_uuid"
                optionLabel="email"
                optionValue="uuid"
                appendTo="body"
                [showClear]="true"
                [loading]="userDropdownLoading"
            >
                <ng-template pTemplate="emptyfilter">
                    <div *ngIf="userDropdownLoading" style="text-align: center">
                        <p-progressSpinner
                            styleClass="w-2rem h-2rem"
                            strokeWidth="4"
                            animationDuration="1.5s"
                        ></p-progressSpinner>
                        <div class="mt-2 mb-2">Loading users...</div>
                    </div>
                    <div *ngIf="!userDropdownLoading" style="text-align: center">No user(s) found</div>
                </ng-template>

                <ng-template pTemplate="empty">
                    <div *ngIf="userDropdownLoading" style="text-align: center">
                        <p-progressSpinner
                            styleClass="w-2rem h-2rem"
                            strokeWidth="4"
                            animationDuration="1.5s"
                        ></p-progressSpinner>
                        <div class="mt-2 mb-2">Loading users...</div>
                    </div>
                    <div *ngIf="!userDropdownLoading" style="text-align: center">No user(s) found</div>
                </ng-template>
            </p-select>
            <label for="user_uuid">User</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <p-select
                inputId="user_role_uuid"
                [autoDisplayFirst]="false"
                [options]="userRoles"
                [filter]="true"
                formControlName="user_role_uuid"
                optionLabel="name"
                optionValue="uuid"
                appendTo="body"
                emptyMessage="Please select an Customer first"
                [showClear]="true"
            >
            </p-select>
            <label for="user_role_uuid">User Role</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <p-datepicker
                id="expiration_date"
                formControlName="expiration_date"
                [showTime]="true"
                [showIcon]="true"
                [readonlyInput]="true"
                [showClear]="true"
                appendTo="body"
            ></p-datepicker>
            <label for="expiration_date">Expiration date</label>
        </p-floatlabel>
    </app-ibase-cru-modal-content>
</form>
